import { contextFactory } from '~/utils/contextFactory';

interface DialogContext {
  open: boolean;
  onCloseDialog: () => void;
}

export const [DialogContext, useDialogContext] = contextFactory<DialogContext>();
